import "./Inputs.scss";
import classNames from "classnames";
import React from "react";
import { t } from "i18next";

interface TooltipWrapperSVGProps {
    children: React.ReactNode,
    className?: string,
    tooltipKey?: string
}

const TooltipWrapperSVG = ({ children, tooltipKey, className }: TooltipWrapperSVGProps) => {
    let passKey = {};
    if (tooltipKey) passKey = { "data-tooltip": t(tooltipKey) };

    return (
        <div
            data-testid="tooltipWrapperSvg"
            className={classNames("hrb-tooltip-svg", className, { "hrb-tooltip": tooltipKey })}
            {...passKey}
        >{children}</div>
    )
};

export default TooltipWrapperSVG;